import NumberFormat from 'react-number-format';
import { KeyTypes } from '../../app/enums';
import { Typography, Grid} from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { CartItem } from '../../models/cart.interface';

const useStyles = makeStyles((theme: Theme) =>
  createStyles ({
    fontMedium: {
      fontSize: 14,
      color: theme.palette.text.primary,
    },
    fontSmall: {
      fontSize: 12,
      color: theme.palette.text.primary,
    },
    gridSpacer: {
      minHeight: '12px',
    },
  }),
);

export interface IPrintCartLine {
  cartItem: CartItem
}

export const PrintCartLine = ({
  cartItem
}: IPrintCartLine) => {
  const classes = useStyles();
  
  let vehicle = cartItem.vehicleInfo 
    ? <Typography className={classes.fontMedium} style={{ fontWeight: 600 }}>
        {cartItem.vehicleInfo.year} {cartItem.vehicleInfo.make} {cartItem.vehicleInfo.model}
      </Typography>
    : ''

  let vin = (cartItem.vehicleInfo !== undefined && cartItem.vehicleInfo.vin !== undefined)
    ? <Typography className={classes.fontSmall}>
        {cartItem.vehicleInfo.vin}
      </Typography>
    : ''

  return (
    <>
      <Grid container spacing={0} justifyContent="space-between" alignItems="stretch">
        <Grid container justifyContent="space-between">
          {vehicle}
          <Typography className={classes.fontMedium}>
            <NumberFormat 
              value={cartItem.price * cartItem.quantity} 
              displayType={'text'} 
              thousandSeparator={true} 
              prefix={'$'} 
              decimalScale={2}
              fixedDecimalScale={true}
              />
          </Typography>
        </Grid>
        <Grid container justifyContent="space-between">
          {vin}
          <Typography className={classes.fontSmall}>
            each {'  '}
            <NumberFormat 
              value={cartItem.price} 
              displayType={'text'} 
              thousandSeparator={true} 
              prefix={'$'} 
              decimalScale={2}
              fixedDecimalScale={true}
              />
          </Typography>
        </Grid>
        <Grid container justifyContent="space-between">
          <Typography className={classes.fontSmall}>
            {KeyTypes[cartItem.keyType as keyof typeof KeyTypes]}
          </Typography>
          <Typography className={classes.fontSmall}>
            Qty: {cartItem.quantity}
          </Typography>
        </Grid>
        {cartItem?.lotNumber && 
          <Grid container>
            <Typography className={classes.fontSmall}>
              Lot #: {cartItem.lotNumber}
            </Typography>
          </Grid>
        }
        {cartItem?.sellerName && 
          <Grid container>
            <Typography className={classes.fontSmall}>
              Seller: {cartItem.sellerName}
            </Typography>
          </Grid>
        }
        <Grid container className={classes.gridSpacer} ></Grid>
      </Grid>
    </>
  );
};

export default PrintCartLine;
